import React from 'react'

const QuizOption = props => null
QuizOption.displayName = 'QuizOption'

export default QuizOption
